module.exports = __webpack_public_path__ + "assets/5726b296026d0e0c13ef8d427eaacd86.mp3";